<template>
  <div class="time">
    <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
    <p>{{ course.startDate }}({{ course.day }}) {{ course.start_time }}~{{ course.end_time }} ({{ course.time }}분)</p>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "inc_course",
  props: {
    idx: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    course: {},
  }),
  watch: {},
  mounted() {
    this.getComplateCoarcingDetail();
  },
  methods: {
    getComplateCoarcingDetail() {
      let params = {
        sessionIdx: this.idx,
      };
      this.axios
        .get("/front/coarching/complete/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.course = res.data.contentinfo;

            this.course.start_time = dayjs(this.course.completedCoachingDetailDto.startDatetime).format("HH:mm");
            this.course.end_time = dayjs(this.course.completedCoachingDetailDto.endDatetime).format("HH:mm");

            let time_value = {
              start_time: this.course.start_time,
              end_time: this.course.end_time,
            };
            this.$store.commit("setCoachingTime", time_value);
            this.course.time = this.$store.state.coachingTime;

            this.course.startDate = dayjs(this.course.completedCoachingDetailDto.startDatetime).format("YYYY.MM.DD");
            let iosDay = dayjs(this.course.completedCoachingDetailDto.startDatetime).format("YYYY/MM/DD");
            this.$store.commit("setCoachingDays", dayjs(iosDay).day());
            this.course.day = this.$store.state.coachingDays;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
